import type { SearchResults } from 'algoliasearch-helper';

import { EMPTYSEARCH_NB_QUERIES_WITHOUT_HISTORY } from '../constants';

export const generateRandomNumbers = (
  randomNumbers: number,
  nbQueries: number,
): number[] => {
  if (!(randomNumbers || nbQueries)) return [];
  if (randomNumbers > nbQueries) return Array.from(Array(nbQueries).keys());

  const uniqueRandomNumbersArray: number[] = [];

  while (uniqueRandomNumbersArray.length < randomNumbers) {
    const random = Math.floor(Math.random() * nbQueries);

    if (uniqueRandomNumbersArray.indexOf(random) === -1) {
      uniqueRandomNumbersArray.push(random);
    }
  }

  return uniqueRandomNumbersArray;
};

export const randomizeSuggestions = (suggestionsResults: SearchResults) => {
  let { hits } = suggestionsResults;
  const maxNbSuggestions = EMPTYSEARCH_NB_QUERIES_WITHOUT_HISTORY;
  const randomSuggestionsIndexes = generateRandomNumbers(
    maxNbSuggestions,
    hits?.length,
  );

  hits =
    randomSuggestionsIndexes?.length > 0
      ? hits?.filter((_, i) => randomSuggestionsIndexes.includes(i))
      : hits.slice(0, maxNbSuggestions);

  return { ...suggestionsResults, hits };
};
